import React from 'react';
import { NavLink } from 'react-router-dom';
import img from './fblogo.png';
import './Footer.css';

const Footer = () => {
    var kontener = {
        position: 'relative',
        width: '60%',
        zIndex: '99',
        padding: '3em 20%',
        background: '#CBBFAA'
    };
    var follow = {
        marginTop: '1.5em'
    }
    return (
        <div className="foot">
            <div style={kontener}>
                <div className="infoot">
                    <h3>Skontaktuj się z nami</h3>
                    <ul>
                        <li><span><strong>Adres:</strong></span><span> ul. Nowa 35 <br/>62-080 Lusowo k. Poznania</span></li>
                        <li><span><strong>Tel.:</strong></span><span>+48 725 520 620<br/>+48 607 577 052</span></li>
                        <li><span><strong>E-Mail:</strong></span><span> biuro@willastarawozownia.pl</span></li>
                       {/*} <li style={follow}><strong>Śledź nas na facebooku</strong></li>
                        <li className="scfb"><a href="https://facebook.com"><img src={img}></img></a></li>*/}
                    </ul>
                </div>
                <div className="infoot2">
                    <h3>Menu</h3>
                    <ul>
                    <li><NavLink to="/" exact>Strona Główna</NavLink></li>
                <li><NavLink to="/o-nas">O Nas</NavLink></li>
                <li><NavLink to="/kontakt">Kontakt</NavLink></li>
                <li><NavLink to="/pokoje">Pokoje</NavLink></li>
                <li><NavLink to="/restauracja">Restauracja Stara Wozownia</NavLink></li>
                <li><NavLink to="/okolica">Okolica</NavLink></li>
                    </ul>
                </div>
            </div>
        </div>
    )
}
export default Footer;


// WEBPACK FOOTER //
// ./src/Footer/Footer.js